import React from 'react'
import { Heading } from '../components/Heading';
import { ChannelsAdminPage } from '../components/ChannelsAdmin/ChannelsAdminPage';

export function Channels() {
    return (
        <>
            <Heading title="Canales" />
            <div className="container">
                <ChannelsAdminPage />
            </div>
        </>
    )
}

export default Channels